<template>
    <div class="col-lg-10 col-md-8 col-12 main">
        <!-- <Swiper :list="list" /> -->
        <!-- <div ref="masonry" class="masonry-js">
            <div v-for="(item, i) in list" :key="i" class="item">
                <img :src="item.img" :alt="item.alt">
                <div class="caption">示例项 ${i} — 高度 ${h}px</div>
            </div>
        </div> -->
        <div ref="masonry" class="masonry-js row"></div>
    </div>
</template>
<script>
import Swiper from "@/components/Swiper.vue";
export default {
    name: "home",
    components: {
        // Swiper
    },
    methods: {
        createMasonry(container, options = {}) {
            const breakpoints = options.columnsBreakpoints || [
                { width: 1200, cols: 4 },
                { width: 900, cols: 3 },
                { width: 600, cols: 2 },
                { width: 0, cols: 1 },
            ];

            let columns = [];
            let colCount = 0;

            const getColsByWidth = (w) => {
                for (const bp of breakpoints) if (w >= bp.width) return bp.cols;
                return 1;
            };

            const buildColumns = (n) => {
                if(!container) return;
                container.innerHTML = "";
                columns = [];
                for (let i = 0; i < n; i++) {
                    const c = document.createElement("div");
                    c.className = "masonry-column";
                    if(container) container.appendChild(c);
                    columns.push(c);
                }
            };

            const getShortestColumnIndex = () => {
                let min = Infinity,
                    idx = 0;
                columns.forEach((col, i) => {
                    const h = col.scrollHeight;
                    if (h < min) {
                        min = h;
                        idx = i;
                    }
                });
                return idx;
            };

            const addItemElement = (el) => {
                const imgs = el.querySelectorAll("img");
                if (imgs.length === 0) {
                    if(columns[getShortestColumnIndex()]) columns[getShortestColumnIndex()].appendChild(el);
                    return;
                }
                let loaded = 0;
                imgs.forEach((img) => {
                    const done = () => {
                        loaded++;
                        if(loaded === imgs.length && columns[getShortestColumnIndex()]){
                            columns[getShortestColumnIndex()].appendChild(el);
                            let item = img.parentElement.parentElement;      
                            if (item) {
                                item.classList.remove(...item.classList);       // 清空所有 class
                                item.classList.add('item', `col-${12 / colCount}`);  // 添加新类
                            }                                      
                        }                   
                    };
                    if (img.complete) done();
                    else {
                        img.addEventListener("load", done);
                        img.addEventListener("error", done);
                    }
                });
            };

            const addItems = (items) => {
                items.forEach((el) => {
                    if (!(el instanceof HTMLElement)) return;
                    addItemElement(el);
                });
            };

            const relayout = () => {
                const newCols = getColsByWidth(window.innerWidth);
                if (newCols === colCount) return;
                const allItems = [];
                columns.forEach((c) => allItems.push(...c.children));
                buildColumns(newCols);
                colCount = newCols;
                allItems.forEach((item) => {
                    columns[getShortestColumnIndex()].appendChild(item)
                    const parent = item.parentElement;
                    // masonry-column
                    if (parent && parent.classList) {
                        parent.classList.remove(...parent.classList);       // 清空所有 class
                        parent.classList.add('item', `col-${12 / colCount}`);  // 添加新类
                    }                             
                });
            };

            colCount = getColsByWidth(window.innerWidth);
            buildColumns(colCount);

            window.addEventListener("resize", () => {
                clearTimeout(window.__masonry_resize_timer);
                window.__masonry_resize_timer = setTimeout(relayout, 120);
            });

            return { addItems, relayout, container };
        },
    },
    mounted() {
        // 初始化 Masonry 布局
        const container = this.$refs.masonry;
        const mason = this.createMasonry(container, {
            columnsBreakpoints: [
                { width: 1200, cols: 4 },
                { width: 900, cols: 3 },
                { width: 600, cols: 2 },
                { width: 0, cols: 1 },
            ],
        });

        // 生成每个 item 的 DOM（Vue 仅负责数据）
        const items = this.list.map((item, i) => {
            const el = document.createElement("div");
            el.className = "item";
            el.innerHTML = `
                <img src="${item.img}" width="100%" alt="${item.alt}" />
                <div class="caption">&nbsp;</div>
            `;
            return el;
        });

        mason.addItems(items);
    },
    data() {
        return {
            list: [
                { img: require("@/assets/resource/visual_art/design/1.png"), alt: "123" },
                { img: require("@/assets/resource/visual_art/design/2.png"), alt: "123" },
                { img: require("@/assets/resource/visual_art/design/3.png"), alt: "123" },
                { img: require("@/assets/resource/visual_art/design/4.png"), alt: "123" },
                { img: require("@/assets/resource/visual_art/design/5.png"), alt: "123" },
                { img: require("@/assets/resource/visual_art/design/6.png"), alt: "123" },
                { img: require("@/assets/resource/visual_art/design/7.png"), alt: "123" },
                { img: require("@/assets/resource/visual_art/design/8.png"), alt: "123" },
                { img: require("@/assets/resource/visual_art/design/9.jpg"), alt: "123" },
                { img: require("@/assets/resource/visual_art/design/10.jpg"), alt: "123" },
                { img: require("@/assets/resource/visual_art/design/11.jpg"), alt: "123" },
                { img: require("@/assets/resource/visual_art/design/12.jpg"), alt: "123" },
                { img: require("@/assets/resource/visual_art/design/13.jpg"), alt: "123" },
                { img: require("@/assets/resource/visual_art/design/14.jpg"), alt: "123" },
                { img: require("@/assets/resource/visual_art/design/15.jpg"), alt: "123" },
                { img: require("@/assets/resource/visual_art/design/16.jpg"), alt: "123" },
                { img: require("@/assets/resource/visual_art/design/17.jpg"), alt: "123" },
                { img: require("@/assets/resource/visual_art/design/18.jpg"), alt: "123" },
                { img: require("@/assets/resource/visual_art/design/19.jpg"), alt: "123" },
                { img: require("@/assets/resource/visual_art/design/20.jpg"), alt: "123" },
                { img: require("@/assets/resource/visual_art/design/21.jpg"), alt: "123" },
                { img: require("@/assets/resource/visual_art/design/22.jpg"), alt: "123" },
                { img: require("@/assets/resource/visual_art/design/24.jpg"), alt: "123" },
                { img: require("@/assets/resource/visual_art/design/25.jpg"), alt: "123" },
                { img: require("@/assets/resource/visual_art/design/26.jpg"), alt: "123" },                     
                { img: require("@/assets/resource/visual_art/design/27.jpg"), alt: "123" },     
                { img: require("@/assets/resource/visual_art/design/28.jpg"), alt: "123" },     
                { img: require("@/assets/resource/visual_art/design/29.jpg"), alt: "123" },     
                { img: require("@/assets/resource/visual_art/design/30.jpg"), alt: "123" },     
                { img: require("@/assets/resource/visual_art/design/31.jpg"), alt: "123" },     
                { img: require("@/assets/resource/visual_art/design/32.jpg"), alt: "123" },     
                { img: require("@/assets/resource/visual_art/design/33.jpg"), alt: "123" },     
                { img: require("@/assets/resource/visual_art/design/34.jpg"), alt: "123" },     
                { img: require("@/assets/resource/visual_art/design/35.jpg"), alt: "123" },     
                { img: require("@/assets/resource/visual_art/design/36.jpg"), alt: "123" },     
                { img: require("@/assets/resource/visual_art/design/37.jpg"), alt: "123" }, 
                { img: require("@/assets/resource/visual_art/design/39.jpg"), alt: "123" }, 
            ],
        }
    },


};
</script>
<style scoped>
/* 
*{border:1px solid #000;} */

.main {
    height: 100vh;
    padding: 30px 15px;
}

.masonry-js {
  display: flex;
  align-items: flex-start;
  width: 100%;
}

.masonry-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.item {
  background: #fff;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
  transition: transform 0.2s ease;
}
.item:hover {
  transform: translateY(-4px);
}

.item img {
  width: 100%;
  display: block;
  height: auto;
}

.caption {
  padding: 8px;
  font-size: 14px;
  color: #333;
}

@media (max-width: 768px) {
    .main {
        padding-top: 0px;
        height: calc(100vh - 90px);
    }

}
</style>